import React from 'react';
import { Link } from 'react-router-dom';
import externalLinkIcon from '../Images/external link.svg';

type HeroCtaItem = {
  id: string;
  title: string;
  subtext: string;
  to: string;
  ariaLabel: string;
};

const heroCtaItems: HeroCtaItem[] = [
  {
    id: 'join',
    title: 'Набор в команду',
    subtext: 'Станьте членом команды уже сейчас!',
    to: '/join',
    ariaLabel: 'Перейти на страницу вступления в команду',
  },
  {
    id: 'survey',
    title: 'Пройдите опрос',
    subtext: 'Нам важно знать, как улучшить сервис и сделать его полезнее для вас.',
    to: '/survey',
    ariaLabel: 'Перейти к опросу о том, как улучшить сервис',
  },
];

const Hello: React.FC = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [rotationResetKey, setRotationResetKey] = React.useState(0);

  React.useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setActiveIndex((current) => (current + 1) % heroCtaItems.length);
    }, 10000);

    return () => window.clearTimeout(timeoutId);
  }, [activeIndex, rotationResetKey]);

  const currentCta = heroCtaItems[activeIndex];

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
    setRotationResetKey((current) => current + 1);
  };

  return (
    <section className="hello">
      <p className="hello__eyebrow">Платформа студенческих активностей</p>
      <h1 className="hello__title">Celestix</h1>
      <p className="hello__text">
        Будущее начинается с тебя — и прямо сейчас его можно не только ждать, но и собирать вместе с нами.
      </p>

      <div className="hello__actions">
        <Link className="hello__bar btn" to="/changelog">Следить за развитием</Link>

        <div className="hello__progress-wrap">
          <Link
            className="hello__progress"
            to={currentCta.to}
            aria-label={currentCta.ariaLabel}
          >
            <span className="hello__progress-track" aria-hidden="true">
              <span className="hello__progress-fill"></span>
            </span>

            <div className="hello__progress-dots" aria-label="Сценарии быстрого действия">
              {heroCtaItems.map((item, index) => (
                <button
                  key={item.id}
                  type="button"
                  className={`hello__progress-dot${index === activeIndex ? ' hello__progress-dot--active' : ''}`}
                  aria-label={item.title}
                  aria-pressed={index === activeIndex}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleDotClick(index);
                  }}
                />
              ))}
            </div>

            <span key={currentCta.id} className="hello__progress-copy hello__progress-copy--animated">
              <span className="hello__progress-text">{currentCta.title}</span>
              <span className="hello__progress-subtext">{currentCta.subtext}</span>
            </span>
            <span className="hello__progress-value">12%</span>
            <span className="hello__progress-link" aria-hidden="true">
              <img src={externalLinkIcon} alt="" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hello;
